import { render, staticRenderFns } from "./ATabulatorLoder.vue?vue&type=template&id=33586441&"
import script from "./ATabulatorLoder.vue?vue&type=script&lang=js&"
export * from "./ATabulatorLoder.vue?vue&type=script&lang=js&"
import style0 from "./ATabulatorLoder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports